import clsx from "clsx";
import { FC, PropsWithChildren } from "react";
import { useTranslation } from "react-i18next";
import { useRecoilValue } from "recoil";

import { MuiButton } from "@ryde/controls";
import { isInnerItemEditingAtom, RydeUiUnit } from "@ryde/shared";

import { ExpandEditFormFooterFlow } from "./expand-edit-form-footer";
import { FormFooterStyled } from "./form-footer.styled";

interface IFormFooterProps extends PropsWithChildren {
  onSaveClick?: () => void;
  onCancelClick?: () => void;
  isLoading?: boolean;
  saveLabel?: string;
  isSaveDisabled?: boolean;
  isInnerItemEditing?: boolean;
  cancelLabel?: string;
  entity?: RydeUiUnit;
}

export const FormFooter: FC<IFormFooterProps> = ({
  entity,
  onSaveClick,
  onCancelClick,
  isLoading = false,
  saveLabel,
  isSaveDisabled = false,
  isInnerItemEditing: isInnerItemEditingProp,
  cancelLabel,
  children,
}) => {
  const { t } = useTranslation();
  const isInnerItemEditingFromAtom = useRecoilValue(isInnerItemEditingAtom);
  const isInnerItemEditing =
    isInnerItemEditingProp ?? isInnerItemEditingFromAtom;

  return (
    <FormFooterStyled
      className={clsx(isInnerItemEditing && "inner-item-editing")}
    >
      <MuiButton
        e2eData="cancel_button_right_footer"
        muiVariant="outlined"
        color="secondary"
        onClick={onCancelClick}
        loading={isLoading}
      >
        {cancelLabel || t(`general.CANCEL`)}
      </MuiButton>
      {Boolean(onSaveClick) && (
        <MuiButton
          e2eData="save_button_right_footer"
          loading={isLoading}
          muiStyle={isSaveDisabled || isInnerItemEditing ? "error" : "primary"}
          disabled={isSaveDisabled || isInnerItemEditing}
          onClick={onSaveClick}
        >
          {saveLabel || t(`general.SAVE`)}
        </MuiButton>
      )}
      {!!children && <>{children}</>}
      {!!entity && entity !== "unknown" && (
        <ExpandEditFormFooterFlow entity={entity} onSaveClick={onSaveClick} />
      )}
    </FormFooterStyled>
  );
};
